import { MOBILE_WIDTH } from "@/constants/components";
import useGetViewPortResize from "@/hooks/useGetViewportResize";
import { css } from "@emotion/react";
import { colors, VStack } from "goi_common";

export default function HeadBanner() {
  const { viewportSize } = useGetViewPortResize();
  return (
    <VStack gap={viewportSize > MOBILE_WIDTH ? 8 : 2} css={bannerCss}>
      <div
        className={viewportSize > MOBILE_WIDTH ? "head2_b warmGray800" : "subtitle2_b warmGray800"}
      >
        고이가 직접, 까다롭게 선별했어요.
      </div>
      <div className={viewportSize > MOBILE_WIDTH ? "subtitle3 gray500" : "body3_m gray500"}>
        엄선된 장례지도사와 장지(납골당)까지 동행해요.
      </div>
    </VStack>
  );
}

const bannerCss = css({
  background: colors.warmGray200,
  padding: "20px 24px",
  [`@media(min-width:${MOBILE_WIDTH}px)`]: {
    padding: "40px 24px",
  },
});
